import React, { useCallback, useState } from 'react'
import { ScheduleFilled } from '@ant-design/icons';
import { Tabs } from 'antd';
import HelpObject from './components/HelpObject'
import HelpRelation from './components/HelpRelation';
const { TabPane } = Tabs;

function Index() {
  const [key, setKey] = useState('1')
  const click = useCallback((e: any)=>{
    setKey(e)  
  },[])
  
  return (
    <div style={{padding: '15px', background: '#fff'}} >
      <Tabs defaultActiveKey="1" activeKey={key} onChange={click}>
        <TabPane tab={ <span><ScheduleFilled />帮扶学科确认</span> }  key="1" ><HelpObject /></TabPane>
        
        <TabPane tab={ <span><ScheduleFilled/>帮扶关系调整</span> } key="2" ><HelpRelation /></TabPane>
      </Tabs>
    </div>
  )
}

export default Index